import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { AccessoriesFrontPannelIcon } from "@jti/brand-icons/accessories-front-pannel";
import { DeviceDefaultIcon } from "@jti/brand-icons/device-default";
import { DevicePenIcon } from "@jti/brand-icons/device-pen";
import { DeviceTimeIcon } from "@jti/brand-icons/device-time";
import { DiamondIcon } from "@jti/brand-icons/diamond";
import { HandChooseIcon } from "@jti/brand-icons/hand-choose";
import { HandCoinsIcon } from "@jti/brand-icons/hand-coins";
import { HandDobbleIcon } from "@jti/brand-icons/hand-dobble";
import { StickIcon } from "@jti/brand-icons/stick";
const ProductTypeIconMap = {
    stick: _jsx(StickIcon, {}),
    ploomdevice: _jsx(DeviceDefaultIcon, {}),
    accessories: _jsx(AccessoriesFrontPannelIcon, {}),
    limitededition: _jsx(DiamondIcon, {}),
};
const ServicesIconMap = {
    tryadevice: _jsx(HandChooseIcon, {}),
    borrowadevice: _jsx(DeviceTimeIcon, {}),
    tradeyourdevice: _jsx(HandDobbleIcon, {}),
    membergetmember: _jsx(HandCoinsIcon, {}),
    customizeyourdevice: _jsx(DevicePenIcon, {}),
};
const ColorForProductMap = {
    amarillo: "--des-color-brand-content-product-yellow2-default",
    amber: "--des-color-brand-content-product-orange2-deepen",
    aquamarine: "--des-color-brand-content-product-blue3-default",
    azure: "--des-color-brand-content-product-blue4-default",
    baizeoption: "--des-color-brand-content-product-orange3-default",
    bronze: "--des-color-brand-content-product-brown2-default",
    burgundy: "--des-color-brand-content-product-red2-default",
    cobalt: "--des-color-brand-content-product-blue1-default",
    ecru: "--des-color-brand-content-product-yellow4-default",
    fluo: "--des-color-brand-content-product-green3-default",
    garnet: "--des-color-brand-content-product-pink2-default",
    gleamoption: "--des-color-brand-content-product-orange1-default",
    gold: "--des-color-brand-content-product-yellow1-default",
    green: "--des-color-brand-content-product-green1-default",
    greenoption: "--des-color-brand-content-product-green2-default",
    magenta: "--des-color-brand-content-product-purple3-default",
    marine: "--des-color-brand-content-product-blue2-default",
    orange: "--des-color-brand-content-product-orange2-default",
    purple: "--des-color-brand-content-product-purple2-default",
    purpleoption: "--des-color-brand-content-product-purple1-default",
    ruby: "--des-color-brand-content-product-red3-default",
    rubyoption: "--des-color-brand-content-product-red1-default",
    silver: "--des-color-brand-content-product-grey1-default",
    tan: "--des-color-brand-content-product-pink3-default",
    tealgreen: "",
    teal: "--des-color-brand-content-product-teal1-default",
    velvet: "--des-color-brand-content-product-red4-default",
    yellow: "--des-color-brand-content-product-yellow2-default",
};
export const getStoreFilterCategoryIcon = ({ categoryKey, filterKey, filtersItemIconContainerClassName: filtersItemIconContainer, colorsClassName, }) => {
    const lowerCaseFilterKey = filterKey?.toLocaleLowerCase().replaceAll(" ", "");
    if (categoryKey === "ProductColors" || categoryKey === "ProductFlavours") {
        const product = ColorForProductMap[lowerCaseFilterKey];
        return (product && (_jsx("div", { style: { background: `var(${product})` }, className: classNames(filtersItemIconContainer, colorsClassName) })));
    }
    if (categoryKey === "product_types") {
        const productTypeIcon = ProductTypeIconMap[lowerCaseFilterKey];
        return productTypeIcon && _jsx("div", { className: classNames(filtersItemIconContainer), children: productTypeIcon });
    }
    if (categoryKey === "services") {
        const servicesIcon = ServicesIconMap[lowerCaseFilterKey];
        return servicesIcon && _jsx("div", { className: classNames(filtersItemIconContainer), children: servicesIcon });
    }
    return undefined;
};
//# sourceMappingURL=getStoreFiltersIcons.js.map